import styled from "styled-components";

const Wrapper = styled.div`
    grid-area: sidebar;
    //width: 100%;
    height: 100%;
    background-color: var(--eb-80CBC4);

    transition: width 2s;

    overflow: hidden;
`;

export default Wrapper;